import { connect } from 'react-redux'
import MapComponent from '../components/Map'

const mapStateToProps = state => {
  return {
    mapActions : state.mapActions,
    mapObject : state.mapObject,
  }
}

const Map = connect(
  mapStateToProps
)(MapComponent)

export default Map



// WEBPACK FOOTER //
// ./src/containers/Map.js